import script from "./vue-upload-drop-images.vue?vue&type=script&setup=true&lang=js"
export * from "./vue-upload-drop-images.vue?vue&type=script&setup=true&lang=js"

import "./vue-upload-drop-images.vue?vue&type=style&index=0&id=05ef04af&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05ef04af"]])

export default __exports__